import "@abgov/web-components";
import './App.scss'
import { GoabAppHeader, GoabAppHeaderMenu, GoabButton, GoabButtonGroup, GoabCircularProgress, GoabModal, GoabOneColumnLayout, GoabPageBlock } from "@abgov/react-components";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Nav } from "./components/nav/Nav";
import { LoggedOut } from "./pages/loggedOut/LoggedOut";
import { useEffect, useState, useRef } from "react";
import { UserCtrl } from "./pages/userCtrl/userCtrl";
import { useAuth } from "react-oidc-context";
import { Home } from "./pages/home/Home";
import { MyAccount } from "./pages/myAccount/MyAccount";
import { RoleList } from "./pages/roleManagement/roleList/roleList";
import { RoleDetails } from "./pages/roleManagement/roleDetails.tsx/roleDetails";
import { useFeatureFlags } from "./hooks/useFeatureFlags";
import { hasResourceRole } from "./common/utils/tokenUtil";
// import { TokenTestComponent } from "./components/TokenTestComponent";
//import { TokenStatus } from "./components/TokenStatus";
//import { NetworkStatus } from "./components/NetworkStatus";
import { VersionBar, VersionBarEnvironment } from 'shared-ui-component';
import "shared-ui-component/dist/index.css";
import { appBuildLabel, appEnv, appResourceId, appVersionLabel } from "./common/constants";

const resourceId = appResourceId;
const roleManagerPermission = 'Adm_RoleManager_W';

function App(props: any) {
  const auth = useAuth();
  const { flagsLoading, hasFlag } = useFeatureFlags();
  
  
  const [tokenExpiringDlg,setTokenExpiringDlg]  = useState(false); 
  const logoutTimer= useRef(0);
  // auth.events.addUserLoaded(()=>{
  //   console.log("Access token - user loaded");
  // });



  // Helper function to detect network errors
  // const isNetworkError = useCallback((error: any): boolean => {
  //   return (
  //     !navigator.onLine ||
  //     error.message?.includes('Failed to fetch') ||
  //     error.message?.includes('Network Error') ||
  //     error.message?.includes('ERR_NETWORK') ||
  //     error.message?.includes('ERR_INTERNET_DISCONNECTED') ||
  //     error.code === 'NETWORK_ERROR' ||
  //     error.status === 0 ||
  //     (error.response && error.response.status >= 500)
  //   );
  // }, []);

  // // Helper function to handle network error retry with exponential backoff
  // const handleNetworkErrorRetry = useCallback(() => {
  //   let retryCount = 0;
  //   const maxRetries = 3;
  //   const baseDelay = 2000; // 2 seconds

  //   const attemptRetry = () => {
  //     if (retryCount >= maxRetries) {
  //       console.log('🚪 Max network retries exceeded - redirecting to login...');
  //       auth.signinRedirect();
  //       return;
  //     }

  //     const delay = baseDelay * Math.pow(2, retryCount); // Exponential backoff
  //     retryCount++;
      
  //     console.log(`🔄 Network retry attempt ${retryCount}/${maxRetries} in ${delay}ms...`);
      
  //     setTimeout(() => {
  //       if (!navigator.onLine) {
  //         console.log('📡 Still offline - will retry when online...');
  //         // Listen for online event
  //         const onlineHandler = () => {
  //           window.removeEventListener('online', onlineHandler);
  //           attemptRetry();
  //         };
  //         window.addEventListener('online', onlineHandler);
  //         return;
  //       }

  //       auth.signinSilent().then(() => {
  //         console.log('✅ Network retry successful');
  //       }).catch((retryError) => {
  //         if (isNetworkError(retryError)) {
  //           attemptRetry(); // Try again
  //         } else {
  //           console.log('🚪 Non-network error on retry - redirecting to login...');
  //           auth.signinRedirect();
  //         }
  //       });
  //     }, delay);
  //   };

  //   attemptRetry();
  // }, [auth, isNetworkError]);

  // Helper function to handle timeout retry
  // const handleTimeoutRetry = useCallback(() => {
  //   console.log('⏱️ Retrying after timeout with longer timeout...');
  //   setTimeout(() => {
  //     // Retry with longer timeout expectations
  //     auth.signinSilent().then(() => {
  //       console.log('✅ Timeout retry successful');
  //     }).catch((retryError) => {
  //       console.error('🚪 Timeout retry failed - redirecting to login...');
  //       auth.clearStaleState();
  //       auth.signinRedirect();
  //     });
  //   }, 5000); // 5 second delay for timeout retry
  // }, [auth]);

  /**************************************************************************
   * 
  ***************************************************************************/
  useEffect(() => {
    const isLoggedOutPath = window.location.pathname === "/logged-out";
    if (!isLoggedOutPath && !auth.isLoading && !auth.isAuthenticated) {
      if (window.location.search) {
        window.location.href = window.location.origin;
      } else {
        auth.clearStaleState();
        auth.signinRedirect();
      }
    }
    // else if (!isLoggedOutPath && !auth.isLoading && auth.isAuthenticated) {
    //   auth.startSilentRenew();
    // }
  }, [auth]);
  
  useEffect(() => {
    // the `return` is important - addAccessTokenExpiring() returns a cleanup function
    if(tokenExpiringDlg === false){
      return auth.events.addAccessTokenExpiring(() => {
        if(logoutTimer.current === 0){
          setTokenExpiringDlg(true);
          logoutTimer.current = window.setTimeout(() => {
            console.log("auto logging out In " +auth.user?.expires_in);
            onLogOut();
            }, (60000*2) /*2 minutes*/);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.events, auth.signinSilent]);

  /**************************************************************************
   * Manual token refresh handling (to avoid refresh token reuse limits)
  ***************************************************************************/
  // useEffect(() => {
  //   let refreshInProgress = false;
    
  //   // Listen for token expiration and manually refresh
  //   const cleanup = auth.events.addAccessTokenExpiring(() => {
  //     if (refreshInProgress) {
  //       console.log('🔄 Refresh already in progress, skipping...');
  //       return;
  //     }
      
  //     refreshInProgress = true;
  //     console.log('⚠️ Access token is expiring - attempting manual refresh...');
      
  //     // Try manual refresh token approach first
  //     auth.signinSilent().then(() => {
  //       console.log('✅ Token refreshed successfully');
  //       refreshInProgress = false;
  //     }).catch((error) => {
  //       console.error('❌ Token refresh failed:', error);
  //       refreshInProgress = false;
        
  //       // Handle network-related errors
  //       if (isNetworkError(error)) {
  //         console.log('🌐 Network error during token refresh - will retry...');
  //         handleNetworkErrorRetry();
  //         return;
  //       }
        
  //       // Handle specific refresh token reuse error
  //       if (error.message && error.message.includes('refresh token reuse')) {
  //         console.log('🔄 Refresh token reuse limit exceeded - redirecting to login...');
  //         auth.signinRedirect();
  //         return;
  //       }
        
  //       // Handle specific auth_time validation error
  //       if (error.message && error.message.includes('auth_time')) {
  //         console.log('🔄 auth_time validation failed - redirecting to login...');
  //         auth.signinRedirect();
  //         return;
  //       }
        
  //       // Handle timeout errors
  //       if (error.message && error.message.includes('timeout')) {
  //         console.log('⏱️ Token refresh timed out - will retry...');
  //         handleTimeoutRetry();
  //         return;
  //       }
        
  //       // For other errors, try one more time after a delay
  //       console.log('🔄 Retrying token refresh once more...');
  //       setTimeout(() => {
  //         if (!refreshInProgress) {
  //           refreshInProgress = true;
  //           auth.signinSilent().catch((retryError) => {
  //             console.error('🚪 Final retry failed:', retryError);
  //             console.log('🚪 Redirecting to login after failed retry');
  //             refreshInProgress = false;
  //             auth.signinRedirect();
  //           }).then(() => {
  //             refreshInProgress = false;
  //           });
  //         }
  //       }, 3000);
  //     });
  //   });

  //   // Listen for token expiration (when refresh fails completely)
  //   const cleanupExpired = auth.events.addAccessTokenExpired(() => {
  //     console.log('❌ Access token expired - redirecting to login');
  //     auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
  //   });

  //   // Listen for silent renew errors - be more graceful
  //   const cleanupSilentRenewError = auth.events.addSilentRenewError((error) => {
  //     console.error('❌ Silent renew error:', error);
  //     // Don't immediately redirect - let the expiring handler try first
  //     console.log('🔄 Silent renew failed, will retry on next expiration event');
  //   });

  //   // Return cleanup function
  //   return () => {
  //     cleanup();
  //     cleanupExpired();
  //     cleanupSilentRenewError();
  //   };
  // }, [auth, handleNetworkErrorRetry, handleTimeoutRetry, isNetworkError]);

  /**************************************************************************
   * 
  ***************************************************************************/
  useEffect(() => {
    // this is for Goab customization/overwrite 
    const GoabH = document.querySelectorAll('Goab-app-header')[0];
    if (GoabH !== undefined) {
      let shadow = GoabH?.shadowRoot;
      const link: HTMLAnchorElement | undefined = shadow?.querySelectorAll('a')[0];
      if (link !== undefined) {
        link.target = '_blank';
      }
    }
  }, []);

  function getMenuTitle() {
    let title = '';
    if (hasFlag('Users') && hasFlag('RoleManagement') && hasFlag('Reporting')) {
      title = 'User access, role management and reporting';
    } else if (hasFlag('Users') && hasFlag('RoleManagement') && !hasFlag('Reporting')) {
      title = 'User access and role management';
    } else if (hasFlag('Users') && !hasFlag('RoleManagement') && hasFlag('Reporting')) {
      title = 'User access and reporting';
    } else if (hasFlag('RoleManagement') && hasFlag('Reporting')) {
      title = 'Role management and reporting';
    } else if (hasFlag('RoleManagement') && !hasFlag('Reporting')) {
      title = 'Role management';
    } else if (hasFlag('Reporting')) {
      title = 'Reporting';
    } else if (hasFlag('Users')) {
      title = 'User access';
    }
    return title;
  }
  /**************************************************************************
   * 
  ***************************************************************************/
  function getPortalUrl(): string {
    let url = 'https://wildfireapps-dev.alberta.ca/';
    if (import.meta.env.VITE_ENV === 'dev' || import.meta.env.VITE_ENV === 'local') {
      url = 'https://wildfireapps-dev.alberta.ca/';
    }
    else if (import.meta.env.VITE_ENV === 'uat') {
      url = 'https://Goab-wdp-wildfire-uat.azurewebsites.net/';
    }
    else if (import.meta.env.VITE_ENV === 'prod') {
      url = 'https://Goab-wdp-wildfire.azurewebsites.net/';
    }
    return url;
  }

    /**************************************************************************
   * 
  ***************************************************************************/
    function onLogOut(){
      auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then( res =>{
          alert(res);
        }
      );
      // close the dialog
      setTokenExpiringDlg(false);
      window.clearTimeout(logoutTimer.current);
      logoutTimer.current = 0;
      //auth.events.removeAccessTokenExpiring(()=>{});
    }
    /**************************************************************************
     * 
    ***************************************************************************/
    function onExtendSession(){
      //auth.startSilentRenew(); // this is to enable automatic silinetRenew..but what we need here is manual renew we trigger the refresh using (signinSilent)
      auth.signinSilent();
      setTokenExpiringDlg(false);
      window.clearTimeout(logoutTimer.current);
      logoutTimer.current = 0;
      //auth.events.removeAccessTokenExpiring(()=>{});
    }
  
  /////////////////////////////////////////////////////////////////////////// 

  return (
    <>
      {/* Shows token refresh status notifications */}
      {/* <TokenStatus /> */}
      
      {/* Shows network connection status */}
      {/* <NetworkStatus /> */}
      
      {/* Version Bar */}
      {!auth.isLoading && <div className='mainContainer'>
        <VersionBar
          environment={appEnv as VersionBarEnvironment}
          environmentLabel={appEnv}
          versionLabel={appVersionLabel}
          buildLabel={appBuildLabel}
        />
      </div>
      }

      <BrowserRouter>
        <GoabOneColumnLayout>
          <section slot="header">
            {/* <GoabMicrositeHeader type="alpha" version={ import.meta.env.MODE } /> */}
            <GoabAppHeader
              url={getPortalUrl()}
              heading="Application Administration"
              maxContentWidth="100%"
            >
              {!auth.isLoading && auth.isAuthenticated && !flagsLoading &&
                <GoabAppHeaderMenu heading={getMenuTitle()} >
                  {hasFlag('Users') && <a href='/'>User maintenance</a>}
                  {hasFlag('RoleManagement') && hasResourceRole(resourceId, roleManagerPermission, auth.user?.access_token as string) && <a href='/role-management'>Role management</a>}
                </GoabAppHeaderMenu>}
              <div>
                {!auth.isLoading && <Nav />}
              </div>
            </GoabAppHeader>
          </section>
          <GoabPageBlock width="100%">
            {/* Temporary debug component - remove in production */}
            {/* {!auth.isLoading && auth.isAuthenticated && <TokenTestComponent />} */}
              <Routes>
                {hasFlag('Users') && <Route path='/' element={<Home />} />}
                {hasFlag('Users') && <Route path='/user-ctrl/:userId' element={<UserCtrl />} />}
                <Route path='/my-account' element={<MyAccount />} />
                <Route path='/logged-out' element={<LoggedOut />} />
                {hasFlag('RoleManagement') &&
                  hasResourceRole(resourceId, roleManagerPermission, auth.user?.access_token as string) &&
                  <Route path='/role-management' element={<RoleList />} />}
                {hasFlag('RoleManagement') &&
                  hasResourceRole(resourceId, roleManagerPermission, auth.user?.access_token as string) &&
                  <Route path='/role-management/:roleId' element={<RoleDetails />} />}
              </Routes>
            {(auth.isLoading && !props.testing) && <GoabCircularProgress variant="fullscreen" size="large" message="Authentication in progress..." visible={true} />}
          </GoabPageBlock>
        </GoabOneColumnLayout>
      </BrowserRouter>
      
      {/******* Modals ******/}
      <GoabModal
        heading="Logout" open={tokenExpiringDlg}
        calloutVariant="emergency"
        role="alertdialog"
        //onClose={() => onLogOut()}
        actions={
          <GoabButtonGroup alignment="end" mt="l">
            <GoabButton type="secondary" onClick={onLogOut}>Log out</GoabButton>
            <GoabButton type="primary" onClick={onExtendSession}>Extend my session</GoabButton>
          </GoabButtonGroup>
        }
      >
      <p>You will be logged out within 2 minutes!</p>
      </GoabModal>

    </>
  );
}

export default App;

